import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'
import { TwoColumnItem, TwoColumnSectionProps } from '@interfaces/product'
import Image from '@components/atoms/Image'
import Button from '../../utils/components/atoms/Button'
import Modal from '../../utils/components/molecules/Modal'

const TwoColumnSection: React.FC<TwoColumnSectionProps> = ({ items }) => {
  const PDPVariant = useSelector((state: RootState) => state.PDP.PDPVariant)
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const itemsToRender = PDPVariant?.whatsInTheBoxData?.items || items
  const featuredItemsToRender = PDPVariant?.featuredTwoColumnData?.items || items

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const renderContentBlock = (item: TwoColumnItem, index: number) => (
    <div key={`content-block-${index}`} className={`flex flex-col ${item.imageAsFirstElement ? 'order-2' : 'order-1'}`}>
      {item.tagline && (
        <span className="text-black body-md font-semibold pb-3 lg:text-[16px] lg:pb-4">{item.tagline}</span>
      )}
      {item.heading && <h2 className="text-black h1 pb-5 lg:pb-6" dangerouslySetInnerHTML={{ __html: item.heading }} />}
      {item.description && (
        <p className="text-black body-md pb-0 lg:pb-10" dangerouslySetInnerHTML={{ __html: item.description }} />
      )}
      {item.cta && (
        <Button
          mode="link"
          className="max-w-245 mt-8 lg:mt-0"
          buttonText={item.button_text as string}
          url={item.cta}
        />
      )}
    </div>
  )

  const renderImageBlock = (item: TwoColumnItem, index: number) => (
    <div key={`image-block-${index}`} className={`flex flex-col ${item.imageAsFirstElement ? 'order-1' : 'order-2'}`}>
      {item.sectionDesktopImage ? (
        <div onClick={() => openModal()} aria-label="Open Modal to zoom Image">
          <Image
            alt={item.tagline || ''}
            src={item.sectionDesktopImage}
            srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280 }}
            width={1536}
            classes="h-full w-full object-cover rounded-lg shadow-lg"
          />
        </div>
      ) : (
        <div className="h-full w-full object-cover rounded-lg shadow-lg bg-gray-300">Placeholder Image</div>
      )}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="relative rounded-b-lg pdp-gallery-modal mac-scroll cursor-zoom-out bg-white mt-5 max-w-3xl w-full overflow-y-auto max-h-[90vh] lg:max-w-screen-lg">
          <div className="flex flex-col gap-2">
            <div  className="w-full">
              <Image src={item.sectionDesktopImage || ''} alt={item.tagline || ''} srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }} zoomable={true} />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )

  return (
    <>
      {featuredItemsToRender.map((item, index) => (
        <div key={`two-column-item-${index}`} className="container section-inner px-5 lg:px-16">
          <div className="justify-between grid grid-cols-1 gap-x-0 gap-y-12 items-center md:flex-row lg:gap-x-20 lg:gap-y-0 lg:grid-cols-2">
            {renderContentBlock(item, index)}
            {renderImageBlock(item, index)}
          </div>
        </div>
      ))}

      {/*{itemsToRender.map((item, index) => (*/}
      {/*  <div key={`two-column-item-${index}`} className="container section-inner px-5 lg:px-16">*/}
      {/*    <div className="justify-between grid grid-cols-1 gap-x-0 gap-y-12 items-center md:flex-row lg:gap-x-20 lg:gap-y-0 lg:grid-cols-2">*/}
      {/*      {renderContentBlock(item, index)}*/}
      {/*      {renderImageBlock(item, index)}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*))}*/}
    </>
  )
}

export default TwoColumnSection
